/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify"; //토스트(toast)
import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import NumberFormat from "react-number-format";

class Pay extends Component {
  state = {};

  _isMounted = false;

  componentDidMount = () => {
    this._isMounted = true;
    this._getData();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getData = async () => {
    const result = await this._getDataApi();
    if (result) {
      const intReturn = result.data[0].intReturn;
      const infoData = result.data[0].listData;

      if (intReturn === 0) {
        if (this._isMounted) {
          this.setState({
            infoData,
            payPrice: infoData[0].dcPrice,
          });
        }
      } else if (intReturn === -2) {
        toast.error("회원 계정에 문제가 발생했습니다.");
        this._close();
      } else if (intReturn === -1) {
        toast.error("존재하지 않는 상품입니다.");
        this._close();
      } else if (intReturn === -3) {
        toast.error("일반 멤버십의 경우 최대 4개까지만 결제가 가능합니다.");
        this._close();
      } else {
        toast.error("존재하지 않는 상품입니다.");
        this._close();
      }
    }
  };

  _getDataApi = () => {
    const { apiUrl, loginId, authId, history } = this.props;
    const { freePassSerial } = this.props.childProps;
    const at = localStorage.getItem("at");

    return axios
      .post(
        apiUrl + "/payInfo",
        {
          params: {
            userid: loginId,
            authId: authId,
            freePassSerial: freePassSerial,
          },
        },
        {
          headers: {
            Authorization: "bearer " + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push("/login");
        }
      });
  };
  _refreshToken = async () => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    const rt = localStorage.getItem("rt");

    if (rt === "" || rt === undefined || rt === null) {
      history.push("/login");
      return false;
    }

    const { data } = await axios.post(apiUrl + "/refreshToken", {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem("at", data[0].at);
      this._getData();
    } else {
      this.setCookie("account", "");

      setLoginId("");
      setAuthId("");

      setTimeout(() => {
        history.push("/login");
      }, 500);
    }
  };

  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie =
      name +
      "=" +
      value +
      ";expires=" +
      expires +
      ";path=/; SameSite=None; Secure; domain=aniplustv.com";
  };

  _selectPayMethod = (payMethod) => {
    const { selectPayMethod } = this.props.childProps;
    selectPayMethod(payMethod);
  };
  _changeCash = (values) => {
    const { infoData } = this.state;
    const { changeCash } = this.props.childProps;
    let useCash;
    if (
      values.value === "" ||
      values.value === undefined ||
      values.value === null
    ) {
      useCash = 0;
    } else {
      useCash = values.value;
    }

    if (infoData[0].remainCash < useCash) {
      toast.warn("보유하신 포인트가 부족합니다.");
    } else {
      if (infoData[0].dcPrice < useCash) {
        useCash = infoData[0].dcPrice;
      }
      changeCash(useCash);
    }

    const payPrice = infoData[0].dcPrice - useCash;

    this.setState({
      payPrice,
    });
  };
  _onPayment = () => {
    const { payPrice } = this.state;
    const { onPayment, onCashOnlyPayment, onCloseAlert } =
      this.props.childProps;
    if (payPrice <= 0) {
      //포인트로만 구매(멤버십 3개월의 경우....)
      onCloseAlert();
      confirmAlert({
        title: "포인트",
        message: "전액 포인트로 결제가 진행됩니다. 계속 하시겠습니까?",
        buttons: [
          {
            label: "결제하기",
            onClick: () => {
              onCashOnlyPayment();
            },
          },

          {
            label: "취소",
          },
        ],
      });
    } else {
      onPayment();
    }
  };
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = "";
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = "," + (parseInt(str) % 1000) + "00" + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = "," + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ",0" + (parseInt(str) % 1000) + Money;
          else Money = ",00" + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _close = () => {
    const { onCloseAlert } = this.props.childProps;
    onCloseAlert();
  };
  render() {
    const { infoData, payPrice } = this.state;
    const { freePassSerial, useCash, payMethod } = this.props.childProps;
    return (
      <Fragment>
        {infoData ? (
          <Fragment>
            <div className="cashcard_close">
              <a style={{ cursor: "pointer" }} onClick={this._close}>
                닫기
              </a>
            </div>

            <div
              className={
                freePassSerial === 10
                  ? "cashcard_pop_layer7"
                  : "cashcard_pop_layer6"
              }
            >
              <div
                className={
                  freePassSerial === 10
                    ? "cashcard_pop_top2"
                    : "cashcard_pop_top"
                }
                style={
                  parseInt(freePassSerial) === 56
                    ? {
                        background:
                          "url(/img/cashcard/pop_cashcard_topbg1.png) no-repeat center bottom",
                        height: 191,
                      }
                    : parseInt(freePassSerial) === 54
                    ? {
                        background:
                          "url(/img/cashcard/pop_cashcard_topbg2.png) no-repeat center bottom",
                        height: 191,
                      }
                    : parseInt(freePassSerial) === 53
                    ? {
                        background:
                          "url(/img/cashcard/pop_cashcard_topbg3.png) no-repeat center bottom",
                        height: 191,
                      }
                    : null
                }
              >
                {freePassSerial === 10 ? (
                  <Fragment>
                    <div className="member01">
                      <img src="img/cashcard/member02.png" />
                    </div>
                    <div className="evn_bg">
                      <img src="img/cashcard/pop_bg.png" />
                    </div>
                  </Fragment>
                ) : (
                  <Fragment>
                    <div className="cashcard_box_top"></div>
                    <div className="cashcard_box">
                      <h1>
                        {/*parseInt(freePassSerial) === 56 ? '프리미엄' : parseInt(freePassSerial) === 54 ? '골드' : parseInt(freePassSerial) === 53 ? '실버' : '기타' */}
                        <span>{infoData[0].freePassName}</span>
                      </h1>
                      <div className="cashcard_box_barcode">
                        {/*<img src="img/cashcard/barcode.jpeg"/><span>3232-2581-9632-1478</span>*/}
                      </div>
                    </div>
                  </Fragment>
                )}
              </div>
              <div className="cashcard_pop_content" style={{ height: 580 }}>
                <h2 className="cashcard_pop_h2_style1">결제내용</h2>
                <table
                  width="100%"
                  border="0"
                  cellSpacing="0"
                  cellPadding="0"
                  className="cashcard_pop_table2"
                >
                  <tbody>
                    {/*
                                <tr>
                                    <th>이용기간</th>
                                    <td className="cashcard_pop_table2_text3">110,000 <span>포인트</span></td>
                                </tr>
                                */}
                    <tr>
                      <th>보유포인트</th>
                      <td>
                        {this._CommaFormatted(infoData[0].remainCash)} 포인트
                        {/*<span>포인트적립(5%)</span>*/}
                      </td>
                    </tr>
                    {freePassSerial === 10 ? (
                      <tr>
                        <th>포인트사용</th>
                        <td className="cashcard_pop_table2_text4">
                          <NumberFormat
                            value={useCash}
                            thousandSeparator={true}
                            onValueChange={(values) => this._changeCash(values)}
                            className="cashcard_pop_table2_text4"
                            style={{
                              backgroundColor: "#1e1d1c",
                              borderWidth: 1,
                              borderColor: "#3188ff",
                              textAlign: "right",
                              fontSize: 15,
                              fontWeight: "700",
                              padding: 2,
                            }}
                            maxLength={7}
                            size={2}
                          />
                          <span style={{ paddingLeft: 3, fontSize: 14 }}>
                            포인트
                          </span>
                        </td>
                      </tr>
                    ) : (
                      <Fragment>
                        <tr>
                          <th>충전포인트</th>
                          <td>
                            {this._CommaFormatted(
                              infoData[0].savePoint + infoData[0].saveCash
                            )}{" "}
                            포인트{/*<span>추가적립(5%)</span>*/}
                          </td>
                        </tr>
                      </Fragment>
                    )}

                    <tr>
                      <td colSpan="2" className="cashcard_pop_table2_text">
                        총결제 금액{" "}
                        <strong>{this._CommaFormatted(payPrice)}원</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style={{ height: 30 }}></div>

                {payPrice <= 0 ? (
                  <Fragment>
                    <h2 className="cashcard_pop_h2_style1">전액 캐쉬 결제</h2>
                  </Fragment>
                ) : (
                  <Fragment>
                    <h2 className="cashcard_pop_h2_style1">결제수단</h2>
                    {/* <div className="img_btn_a"> */}

                    <div className="img_btn_a">
                      {freePassSerial === 10 ? (
                        <>
                          <a
                            onClick={() => this._selectPayMethod("SC0010")}
                            style={{ cursor: "pointer" }}
                          >
                            {payMethod === "SC0010" ? (
                              <img src="img/cashcard/btn_payment01_o.png" />
                            ) : (
                              <img src="img/cashcard/btn_payment01.png" />
                            )}
                          </a>

                          <a
                            onClick={() => this._selectPayMethod("SC0060")}
                            style={{ cursor: "pointer" }}
                          >
                            {payMethod === "SC0060" ? (
                              <img src="img/cashcard/btn_payment02_o.png" />
                            ) : (
                              <img src="img/cashcard/btn_payment02.png" />
                            )}
                          </a>
                          <a
                            onClick={() => this._selectPayMethod("SC0111")}
                            style={{ cursor: "pointer" }}
                          >
                            {payMethod === "SC0111" ? (
                              <img src="img/cashcard/btn_payment03_o.png" />
                            ) : (
                              <img src="img/cashcard/btn_payment03.png" />
                            )}
                          </a>
                          <a
                            onClick={() => this._selectPayMethod("SC0030")}
                            style={{ cursor: "pointer" }}
                          >
                            {payMethod === "SC0030" ? (
                              <img src="img/cashcard/btn_payment04_o.png" />
                            ) : (
                              <img src="img/cashcard/btn_payment04.png" />
                            )}
                          </a>
                        </>
                      ) : (
                        <>
                          <a
                            onClick={() => this._selectPayMethod("SC0010")}
                            style={{ cursor: "pointer" }}
                          >
                            {payMethod === "SC0010" ? (
                              <img src="img/cashcard/btn_payment01_o.png" />
                            ) : (
                              <img src="img/cashcard/btn_payment01.png" />
                            )}
                          </a>
                        </>
                      )}
                    </div>

                    {/* </div> */}
                  </Fragment>
                )}

                <a style={{ cursor: "pointer" }} onClick={this._onPayment}>
                  결제하기
                </a>
              </div>
            </div>
          </Fragment>
        ) : /*
                    <div>s
                        <div>구매</div>
                        {freePassSerial === 10 ? (
                            <Fragment>
                            <div>보유포인트: {infoData[0].remainCash}</div>
                            <div>포인트 사용: 
                                <NumberFormat value={useCash} thousandSeparator={true} suffix={'원'} onValueChange={(values)=>this._changeCash(values)}  />
                            </div>
                            </Fragment>
                        ) : null }
                        <div>
                            총 결제금액 : <NumberFormat value={payPrice} displayType={'text'} thousandSeparator={true} suffix={'원'}/>
                            적립포인트: {infoData[0].saveCash}
                            결제방식 : <span onClick={()=>this._selectPayMethod('SC0010')}>카드</span>|<span onClick={()=>this._selectPayMethod('SC0060')}>휴대폰</span>|<span onClick={()=>this._selectPayMethod('SC0030')}>계좌이체</span>|<span onClick={()=>this._selectPayMethod('SC0111')}>상품권</span>
                        </div>
                        <div onClick={this._onPayment}>결제하기</div>
                    </div>
                    */
        null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Pay));
